import { Button } from '@welbe/design-system';
import React from 'react';
import { ContainerButton } from './AddReminder.styles';

type AddReminderProps = {
	text: string;
	buttonText: string;
	buttonWidth?: string;
	justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between';
	variation?: 'solid' | 'outline';
	disabled?: boolean;
	onConfirm: () => void;
};

export const AddReminder = ({
	text,
	buttonText,
	buttonWidth,
	variation,
	justify,
	disabled,
	onConfirm,
}: AddReminderProps): JSX.Element => {
	return (
		<ContainerButton justify={justify}>
			<p>{text}</p>
			<Button
				disabled={disabled}
				onClick={onConfirm}
				width={buttonWidth ?? '300px'}
				variant={variation ?? 'solid'}
			>
				{buttonText}
			</Button>
		</ContainerButton>
	);
};
